import { Injectable } from '@angular/core';
import { IndexedDbObjectStore } from '../../offline/indexed-db-object-store';
import type {
  StoredWorkflowStorageRecord,
  WorkflowStorageStore,
} from './workflow-storage.types';

/**
 * Отдельная БД регламентов: записи с владельцем не смешиваются со снимками заявок
 * (OutkeepOfflineDB), и очистка снимков пользователя не затрагивает очереди регламентов.
 */
@Injectable({ providedIn: 'root' })
export class WorkflowStorageDatabase implements WorkflowStorageStore {
  private readonly objectStore =
    new IndexedDbObjectStore<StoredWorkflowStorageRecord>({
      databaseName: 'OutkeepWorkflowDB',
      keyPath: 'key',
      storeName: 'records',
      version: 1,
    });

  delete(key: string): Promise<void> {
    return this.objectStore.delete(key);
  }

  entries(): Promise<StoredWorkflowStorageRecord[]> {
    return this.objectStore.entries();
  }

  get(key: string): Promise<StoredWorkflowStorageRecord | null> {
    return this.objectStore.get(key);
  }

  put(record: StoredWorkflowStorageRecord): Promise<void> {
    return this.objectStore.put(record);
  }
}
